import { render } from "./AddTracking.vue?vue&type=template&id=31ba8702&scoped=true"
import script from "./AddTracking.vue?vue&type=script&lang=js"
export * from "./AddTracking.vue?vue&type=script&lang=js"

import "./AddTracking.vue?vue&type=style&index=0&id=31ba8702&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ba8702"]])

export default __exports__